import React, { useMemo } from 'react'
import { Tabs, List, Flex } from 'antd-mobile'
import RedDetailItem from './RedDetailItem'
import { IRedTabItem } from './index.d'
import { StickyContainer, Sticky } from 'react-sticky'

interface RedDetailProps {
  data: IRedTabItem[]
}

const renderTabBar = (props: any) => {
  return (
    <Sticky relative>
      {({ style }) => (
        <div style={{ ...style, zIndex: 3 }}>
          <Tabs.DefaultTabBar {...props} />
        </div>
      )}
    </Sticky>
  )
}

const RedDetail: React.FC<RedDetailProps> = (props) => {
  const { data = [] } = props

  const tabs = useMemo(() => {
    return data.map((i) => ({
      title: i.name,
      key: i.type,
    }))
  }, [data])

  return (
    <StickyContainer>
      <Tabs
        tabs={tabs}
        tabBarActiveTextColor="#ec8135"
        renderTabBar={renderTabBar}
        tabBarUnderlineStyle={{
          border: '1px solid #ec8135',
        }}
      >
        {data.map((i) => (
          <div key={i.type}>
            <Flex
              style={{
                padding: '10px 16px',
                backgroundColor: '#f2f2f2',
              }}
            >
              <Flex.Item>
                <b className="text-md">{i.amount_title}</b>
              </Flex.Item>
              <b className="text-md color-orange">{i.amount}元</b>
            </Flex>
            <List>
              {i.lists.map((k) => (
                <RedDetailItem key={k.id} {...k} />
              ))}
            </List>
          </div>
        ))}
      </Tabs>
    </StickyContainer>
  )
}

export default RedDetail
